import DockingPluginBase from './DockingPluginBase';
import { updateStickyDocking } from './actions/calculateDocking';
import { Editor } from 'roosterjs-editor-core';

export default class StickyDockingPlugin extends DockingPluginBase {
    private stickyBottomBorder: HTMLDivElement;
    private intersectionObserver: IntersectionObserver;

    public getName() {
        return 'StickyDocking';
    }

    public initialize(editor: Editor) {
        super.initialize(editor);

        this.updateIntersectionObserver();
        this.tryScrollIntoView();
    }

    public dispose() {
        this.updateIntersectionObserver();
        super.dispose();
    }

    public setStickyBottomBorder(div: HTMLDivElement) {
        this.stickyBottomBorder = div;
        this.updateIntersectionObserver();
    }

    public setInitialVisiblePart(initialVisiblePart: HTMLDivElement) {
        super.setInitialVisiblePart(initialVisiblePart);
        this.updateIntersectionObserver();
    }

    protected onScrollContainerChanged = (scrollContainer: HTMLDivElement) => {
        this.updateIntersectionObserver();
    };

    private updateIntersectionObserver() {
        const scrollContainer = this.scrollAdapter.getScrollContainer();

        // TODO: Once we support compose projection window, need to make sure the observer code works well in projection window
        // We can check this.viewState.isPopout to know if this is in popout window
        if (this.stickyBottomBorder && this.editor && scrollContainer) {
            if (!this.intersectionObserver) {
                this.intersectionObserver = new IntersectionObserver(
                    (entries: IntersectionObserverEntry[]) => {
                        if (entries[0]) {
                            updateStickyDocking(this.viewState, entries[0].intersectionRatio != 1);
                        }
                    },
                    {
                        rootMargin: '0px',
                        threshold: [1],
                        root: scrollContainer,
                    }
                );
                this.intersectionObserver.observe(this.stickyBottomBorder);
            }
        } else {
            if (this.intersectionObserver) {
                this.intersectionObserver.disconnect();
                this.intersectionObserver = null;
            }
        }
    }
}
